import { mapContentModules } from '../contentModuleMapper';

interface Props {
	content: {
		contentType: 'tabs';
		id: string;
		properties: {
			tabsTitle: string;
			tabSections: {
				items: {
					content: {
						properties: {
							title: string;
							content: { items: Umbraco.ContentModule[] };
						};
					};
				}[];
			};
		};
	};
	settings: {
		properties: {
			hideTitle: boolean;
			width: Content.SectionWidth;
			background: 'Light' | 'Dark';
		};
	};
	siteId?: string;
	locale?: string;
}

export const mapTabs = async ({ content, settings, siteId, locale }: Props): Promise<Content.Tabs> => {
	try {
		return {
			documentType: content?.contentType,
			id: content?.id,
			content: {
				tabsTitle: content?.properties?.tabsTitle,
				tabSections: await Promise.all(
					content?.properties?.tabSections?.items?.map(async (tabSection) => {
						const { title, content: tabContent } = tabSection?.content?.properties ?? {};

						return {
							content: {
								properties: {
									title,
									content: await mapContentModules(tabContent?.items ?? [], siteId, locale),
								},
							},
						};
					}) ?? [],
				),
			},
			settings,
		};
	} catch (e) {
		throw new Error('Could not map Tabs', { cause: e });
	}
};
